import BaseInputAutocomplete from "./BaseInputAutocomplete.vue";

export type { InputAutocompleteResponseItem } from "./BaseInputAutocomplete.vue";
export type { InputAutocompleteResponse } from "./BaseInputAutocomplete.vue";
export default BaseInputAutocomplete;
